import { Grid, Typography, IconButton } from '@mui/material';
import { Form } from '@unform/web';
import 'moment/locale/pt-br';
import React, { useRef } from 'react';
import FirstAccessInput from '~/components/FirstAccessInput';
import api from '~/services/api';
import SnackBar from '~/util/SnackBar';
import * as Style from './styles';

function Login({ ...props }) {
    const formRef = useRef(null);
    const handleFormSubmit = async formData => {
        try {
            formData.salesCode = formData.salesCode.replace(
                /[^a-zA-Z0-9]/g,
                ''
            );
            const userData = await api.post('/manage-users/check-user', {
                codigo_vendedor: formData.salesCode.toUpperCase(),
                cpf: formData.cpf.replace(/\D/g, ''),
            });

            props.setUserData(userData.data.user);
            props.setCurrentPage('register');
            SnackBar.success('Usuario Encontrado');
        } catch (error) {
            if (error?.message === 'Erro de conexão') {
                SnackBar.error(
                    'Falha na conexão. Atualize a página e tente novamente.'
                );
            }
            if (error?.response?.data?.error) {
                SnackBar.error(error.response.data.error);
            } else {
                SnackBar.error('Erro ao buscar usuário');
            }
        }
    };

    const submitForm = () => {
        formRef.current.submitForm();
    };

    return (
        <>
            <Grid container justifyContent="center">
                <Grid item xs={12} md={6}>
                    <Grid container>
                        <IconButton
                            onClick={() => props.setCurrentPage('onboard')}
                        >
                            <Style.StyledIcon/>
                        </IconButton>
                    </Grid>
                    <Style.HeaderContainer container>
                        <Grid item xs={8}>
                            <Typography align="left" variant="h4">
                                Estamos quase lá.
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <Style.HeaderStepNumber
                                variant="h2"
                                align="right"
                            >
                                02
                            </Style.HeaderStepNumber>
                        </Grid>
                    </Style.HeaderContainer>
                    <Grid item container justifyContent="center" spacing={2}>
                        <Style.MainTextContainer item xs={9}>
                            <Style.MainTextTypography
                                variant="body1"
                            >
                                Insira seu código de vendedor e CPF para que
                                possamos te ajudar a completar o cadastro.{' '}
                            </Style.MainTextTypography>
                        </Style.MainTextContainer>
                        <Grid item xs={10}>
                            <Form onSubmit={handleFormSubmit} ref={formRef}>
                                <FirstAccessInput
                                    label="Código de Vendedor"
                                    placeholder="P986"
                                    name="salesCode"
                                />
                                <FirstAccessInput
                                    label="CPF"
                                    placeholder="122.122.122-90"
                                    name="cpf"
                                    mask="999.999.999-99"
                                />
                            </Form>
                        </Grid>
                        <Grid item xs={10} container justifyContent="space-evenly">
                            <Style.DefaultButton
                                onClick={submitForm}
                            >
                                Próximo
                            </Style.DefaultButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default Login;
